import { Trans, useTranslation } from "react-i18next";
import {
  Popup,
  PopupActions,
  PopupContent,
  PopupHeading,
} from "../../components/Common/Popup";
import Button from "../../components/Common/Button";

const WarningLastSubjectNotSelectedDialog = ({ subject, handleOk }) => {
  const { t } = useTranslation();

  console.log("Login warning!!");
  return (
    <Popup>
      <PopupHeading>{t("Picture set added")}</PopupHeading>
      <PopupContent>
        <p>
          {t("%s was successfully added to your account.", {
            postProcess: "sprintf",
            sprintf: [`${subject.name} - ${subject.group}`],
          })}
        </p>
        <p>
          <Trans>
            You can unfortunately not mix pictures from different photographers
            in the same order.
          </Trans>
        </p>
        <p>
          <Trans>
            You must either complete your ongoing order or empty the shopping
            cart.
          </Trans>
        </p>
      </PopupContent>

      <PopupActions>
        <Button onClick={handleOk}>{t("Ok")}</Button>
      </PopupActions>
    </Popup>
  );
};

export default WarningLastSubjectNotSelectedDialog;
